module.exports = __webpack_public_path__ + "img/studio.97d476cd.svg";